import React from 'react';
import handPhone from '../../../static/img/hand_phone.png';

const services = [
  {
    title: 'What technology is CastleCMS built on?',
    text:
      'The core of CastleCMS comes from Plone, the open source CMS with the best security track record, bar none. Written in Python and using a dependable NoSQL database, CastleCMS is not vulnerable to the all-too-common attacks that afflict PHP and SQL systems. But CastleCMS is more than just that: it is a marriage of technologies and ready-to-go integrated services that provides a complete out of the box solution for organizations with sophisticated needs and demanding security and scalability requirements. ',
  },
  {
    title: 'Who built CastleCMS?',
    text:
      'CastleCMS was developed by a highly experienced team from Wildcard Corp., a web development and hosting company located in Stevens Point, Wisconsin. Wildcard Corp. has a 10 year history of providing highly secure, robust systems to large government agencies. Our team includes core contributors and leaders of the open source Plone CMS and community. We combined our Plone and large government systems experience to bring you an even better integrated CMS.',
  },
  {
    title: 'What kind of support is available for CastleCMS?',
    text:
      'CastleCMS is currently available as a tiered cloud-hosted solution, for corporate, local or state government, and federal government / enterprise levels. With the exception of specific integration components used by our largest clients, CastleCMS will be open sourced, giving you the freedom to inspect, enhance, and modify it, and the ability to avoid vendor lock-in. Wildcard Corp. has earned rave reviews from some of the most demanding organizations for its outstanding proactive support. For more information on our support levels, please fill out our no-obligation quote request form.',
  },
  {
    title: 'How much does CastleCMS cost?',
    text:
      'Each CastleCMS project is a custom-developed solution, and each client’s needs vary greatly. We take great pride in being able to integrate CastleCMS with your existing systems and in providing you with design, customization, training, documentation, and support you can rely on. Please contact us for a no-obligation quote, either by emailing us at info@wildcardcorp.com, calling us at +1 (715) 869-3440, or filling out our quote request form. We look forward to hearing about your project requirements and being a part of your solution!',
  },
];

const truncate = (s: string, n = 200) =>
  s.length > n ? `${s.slice(0, n - 1).trimEnd()}…` : s;

const HPBestServices: React.FC = () => {
  return (
    <>
      <section className="hp-services hp-fullbleed" aria-label="Best services">
        <div className="hp-services__container">
          <div className="hp-services__left" aria-hidden="true">
            <img className="hp-services__image" src={handPhone} alt="" />
          </div>

          <div className="hp-services__right">
            <div className="hp-services__heading">
              <h2 className="hp-services__title">FREQUENTLY ASKED QUESTIONS</h2>
              <div className="hp-services__titleRule" />
            </div>

            <div className="hp-services__grid">
              {services.map((s, idx) => (
                <div className="hp-services__item" key={`${s.title}-${idx}`}>
                  <h3 className="hp-services__itemTitle">{s.title}</h3>
                  {/* truncated for display, original text kept in data */}
                  <p className="hp-services__itemText">
                    {truncate(s.text, 150)}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="hp-cta hp-fullbleed" aria-label="Call to action">
        <div className="hp-cta__container">
          <h2 className="hp-cta__title">TRY CASTLE CMS</h2>
          <p className="hp-cta__subtitle">Request a demo and see how it can benefit your organization.</p>

          <div className="hp-cta__actions">
            <a className="hp-cta__btn hp-cta__btn--primary" href="https://github.com/castlecms/" target="_blank" rel="noopener noreferrer" title='Download'>
              <span>DOWNLOAD</span>
              <span className="hp-cta__btnIcon" aria-hidden="true">
                <i className="ion-ios-cloud-download-outline" />
              </span>
            </a>

            <a className="hp-cta__btn hp-cta__btn--secondary" href="contact" target='_self' title='Request Live Demo'>
              <span>LIVE DEMO</span>
              <span className="hp-cta__btnIcon" aria-hidden="true">
                <i className="ion-ios-arrow-right" />
              </span>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default HPBestServices;
